"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNumberFromCurrencyString = getNumberFromCurrencyString;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function getNumberFromCurrencyString(value) {
  switch ((0, _typeof2["default"])(value)) {
    case 'string':
      {
        // TODO: this method currently does not support decimal delimiters other
        // than periods. we need a good way of hooking up to the store and
        // retrieving the delimiter
        var numericString = value.replace(/[^0-9.]/ig, '').trim();
        if (numericString === '') {
          return;
        }
        return Number(numericString);
      }
    case 'number':
      return value;
    default:
      return;
  }
}
//# sourceMappingURL=currency.js.map